import { Injectable } from '@angular/core';
import { AppSettingsService, hd, XSightHttpService } from '@nx-fe/services';
import { Observable } from 'rxjs';

export interface IOutboundEmailConfigV2 {
  isEnabled: boolean;
  fromEmail: string;
  EmailConfigId: number;
}

export interface IOutboundEmailConfiguration {
  emailConfigId: number,
  isEnabled: boolean;
  outboundType: string;
  fromName: string;
  fromEmail: string;
  host: string;
  port: number;
  authentication: string;
  useSsl: boolean;
  userName: string;
  updatePassword: boolean;
  password: string;
  clientId: string;
  tenantId: string;
  clientSecret: string;
  updateClientSecret: boolean;
}

export interface EmailGlobalConfig{
  inbound: InboundEmailConfigSummary[],
  outbound: OutboundEmailConfigSummary[]
}

export interface OutboundEmailConfigSummary {
  EmailConfigId: number,
  sendersEmail: string,
  sendersName: string
}

export interface InboundEmailConfigSummary {
  EmailConfigId: number,
  Host: string,
  Inbox: string
}

/** Service for fetching and saving outbound email configurations */
@Injectable()
export class OutboundEmailSettingsService {
  constructor(private http: XSightHttpService, private appSettings: AppSettingsService) {}

  /** Gets the oubound email configuration */
  public get = (): Observable<IOutboundEmailConfiguration> => {
    return this.http.get<IOutboundEmailConfiguration>(this.appSettings.emailServiceUrl + 'config/outbound');
  };

  /** Gets the outbound email configuration */
  public getGroupEmailConfig = (groupId: number): Observable<IOutboundEmailConfigV2> => {
    return this.http.get<IOutboundEmailConfigV2>(this.appSettings.emailServiceUrl + `config/group/${groupId}/outbound`);
  };

  /** Gets the unassigned email addresses for outbound email config*/
  public getUnassignedEmails = (): Observable<IOutboundEmailConfigV2[]> => {
    return this.http.get<IOutboundEmailConfigV2[]>(this.appSettings.emailServiceUrl + 'config/outbound/unassigned');
  };

  /** Saves the outbound email configuration */
  public update = (value: IOutboundEmailConfiguration): Observable<IOutboundEmailConfiguration> => {
    return this.http.put<IOutboundEmailConfiguration>(this.appSettings.emailServiceUrl + 'config/outbound/v2', value);
  };

  /** Saves the association between outbound email and the group*/
  public saveAssociatedGroup = (groupId: number, value: IOutboundEmailConfigV2): Observable<IOutboundEmailConfigV2> => {
    return this.http.put<IOutboundEmailConfigV2>(this.appSettings.emailServiceUrl + `config/group/${groupId}`, value);
  };

  /** Test the outbound email configuration */
  public test = (email: IOutboundEmailConfiguration): Observable<hd.IHealthCheckResult> => {
    return this.http.post<hd.IHealthCheckResult>(this.appSettings.emailServiceUrl + `config/outbound/test/v2/${email?.emailConfigId ?? -1}`, email);
  };

  public getAllGroupEmailConfig = (): Observable<EmailGlobalConfig> => {
    return this.http.get<EmailGlobalConfig>(this.appSettings.emailServiceUrl + `config`);
  };

  /** Gets full configuration of outbound email */
  public getFullEmailConfig = (emailId: number): Observable<IOutboundEmailConfiguration> => {
    return this.http.get<IOutboundEmailConfiguration>(this.appSettings.emailServiceUrl + `config/outbound/${emailId}/full`);
  };
}
